const countryWithAddressInFront = new Set(["US", "CA", "GB", "FR", "IE"]);
const isAddressInFront = countryCode => countryWithAddressInFront.has(countryCode);
export default isAddressInFront;
